export default __webpack_public_path__ + "static/media/anisha-matharu-and-sabrina-moin-960.fbac659e.jpg";